import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-container content-center" }
const _hoisted_2 = { class: "ac-form-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "email"
}, [
  /*#__PURE__*/_createTextVNode("E Posta "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "(Gerekli)")
], -1)
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "ac-form-control w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "name"
}, "Adı ", -1)
const _hoisted_7 = { class: "ac-form-control w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "name"
}, "Soyadı ", -1)
const _hoisted_9 = { class: "ac-form-control" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "email"
}, "Etiketler ", -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "ac-form-control" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "email"
}, "Telefon Numarası ", -1)
const _hoisted_14 = { class: "flex items-center gap-4" }
const _hoisted_15 = { class: "ac-form-control w-full" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "company"
}, "Şirket ", -1)
const _hoisted_17 = { class: "ac-form-control w-full" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "company"
}, "Şirket Websitesi ", -1)
const _hoisted_19 = { class: "ac-form-control w-full" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "single-line-label",
  for: "category"
}, "Sektör ", -1)
const _hoisted_21 = { class: "ac-form-control" }
const _hoisted_22 = {
  class: "single-line-label",
  for: "body"
}
const _hoisted_23 = { class: "button- w-full justify-center gap-4 flex" }
const _hoisted_24 = {
  type: "submit",
  class: "ac-primary-button"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

import { reactive, computed } from "vue"
import { useStore } from 'vuex';
import Multiselect from 'vue-multiselect'
import VueTooltip from "../reusable/VueTooltip.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'addOrUpdateEmail',
  props: ['existingEMail', 'tags'],
  emits: ['submitted', 'cancel'],
  setup(__props, { emit: __emit }) {

const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile']);


const props = __props
const emit = __emit

const emailSubmission = reactive({
    firstName: props.existingEMail?.firstName || "",
    lastName: props.existingEMail?.lastName || "",
    email: props.existingEMail?.email || "",
    phone: props.existingEMail?.phone || "",
    company: props.existingEMail?.company || "",
    companyUrl: props.existingEMail?.companyUrl || "",
    industry: props.existingEMail?.industry || "",
    desc: props.existingEMail?.desc || "",
    tags: props.existingEMail?.tags || [],
    created: props.existingEMail?.created || new Date(),
    sentBy:  props.existingEMail?.sentBy || userProfile.value.name
});
 
const emitSubmission = () => {
    emit('submitted', emailSubmission)
}

const emitCancel = () => {
    emit('cancel')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "ac-main-form",
      onSubmit: _withModifiers(emitSubmission, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          required: "",
          type: "email",
          id: "email",
          class: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailSubmission.email) = $event))
        }, null, 512), [
          [_vModelText, emailSubmission.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            class: "dashboard-form__input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailSubmission.firstName) = $event))
          }, null, 512), [
            [_vModelText, emailSubmission.firstName]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            class: "dashboard-form__input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailSubmission.lastName) = $event))
          }, null, 512), [
            [_vModelText, emailSubmission.lastName]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_unref(Multiselect), {
          class: "w-full border email-multiselect h-full flex flex-col items-start justify-center relative !text-black mr-4",
          modelValue: emailSubmission.tags,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailSubmission.tags) = $event)),
          multiple: "",
          options: __props.tags,
          placeholder: "Eklemek istediğiniz etiketleri seçin",
          "track-by": "id",
          "select-label": "Seçmek için tıklayın",
          "deselect-label": "Seçimi kaldırmak için tıklayın",
          "selected-label": "Seçildi",
          label: "name"
        }, {
          tag: _withCtx(({option, remove}) => [
            _createElementVNode("span", {
              class: "custom-option",
              style: _normalizeStyle({'backgroundColor': option.color})
            }, [
              _createTextVNode(_toDisplayString(option.name) + " ", 1),
              _createElementVNode("span", {
                class: "remove-option",
                onClick: ($event: any) => (remove(option))
              }, "×", 8, _hoisted_11)
            ], 4)
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          type: "phone",
          id: "phone",
          class: "dashboard-form__input",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((emailSubmission.phone) = $event))
        }, null, 512), [
          [_vModelText, emailSubmission.phone]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "company",
            class: "dashboard-form__input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((emailSubmission.company) = $event))
          }, null, 512), [
            [_vModelText, emailSubmission.company]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            type: "url",
            id: "companyURL",
            class: "dashboard-form__input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((emailSubmission.companyUrl) = $event))
          }, null, 512), [
            [_vModelText, emailSubmission.companyUrl]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "category",
          class: "dashboard-form__input",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((emailSubmission.industry) = $event))
        }, null, 512), [
          [_vModelText, emailSubmission.industry]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("label", _hoisted_22, [
          _createTextVNode("Açıklama "),
          _createVNode(VueTooltip, { explanation: "Eklediğiniz bağlantı ile ilgili önemli detaylar varsa, bunları bu alandan iletebilirsiniz." }, {
            default: _withCtx(() => [
              _createTextVNode("?")
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("textarea", {
          id: "body",
          rows: "5",
          class: "medium-message mb-10 w-full",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((emailSubmission.desc) = $event))
        }, "\n                ", 512), [
          [_vModelText, emailSubmission.desc]
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", _hoisted_24, [
          (!__props.existingEMail)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Oluştur "))
            : (_openBlock(), _createElementBlock("span", _hoisted_26, " Güncelle "))
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: emitCancel,
          class: "ac-secondary-button button__cancel"
        }, "İptal")
      ])
    ], 32)
  ]))
}
}

})